import "../Info/GuardCompanies/SiteConfigurationGroupGuardCompaniesInfoComponent";
import "../Info/Instructions/SiteConfigurationGroupInstructionsInfoComponent";
import "../Info/Notifications/SiteConfigurationGroupNotificationsInfoComponent";
import "./Edit/ConfigurationGroupMonitoringEditComponent";
import "./SiteConfigurationGroupMonitoring.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import SiteConfigurationGroupMonitoringComponentController from "./SiteConfigurationGroupMonitoringComponentController";

export class SiteConfigurationGroupMonitoringComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {
            configurationGroup: "<",
            deleted: "&?",
            site: "<",
        };
        this.controller = SiteConfigurationGroupMonitoringComponentController;
        this.templateUrl = "/App/Components/Site/ConfigurationGroups/Monitoring/SiteConfigurationGroupMonitoring.html";
    }
}

module("mmManagePortal").component(
    "mmSiteConfigurationGroupMonitoring",
    new SiteConfigurationGroupMonitoringComponent(),
);
